import React from 'react'
import s from './navbar.module.scss'
import { Link } from 'react-router-dom'
import MainContainer from '../MainContainer';
import { navbarLinks } from './../../consts/navbar';
import classNames from 'classnames'
import tasnifLogo from '../../utilits/img/tasnif logo.png'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import { IconButton } from '@material-ui/core';
import MenuCom from './Menu';
import { useState } from 'react';

export default function Navbar() {
    const [show,setShow]=useState(false)
    const {pathname} = useLocation()
    return (
        <div className={s.navbar}>
            <MainContainer>
                <div className={s.inner}>
                    <Link to="/" className={s.logo}>
                        <img className={s.img} src={tasnifLogo} alt="Logo" />
                    </Link>
                    <div className={s.links}>
                        {
                            navbarLinks.map(({ path, name }) => (
                                <Link
                                    key={path}
                                    to={path}
                                    className={classNames(s.link,path===pathname? s.active:"")}>
                                    {name}
                                </Link>
                            ))
                        }
                    </div>
                    <div className={s.btn}>
                       <IconButton onClick={()=>setShow(true)}>
                           <MoreHorizIcon/>
                       </IconButton>
                    </div>
                </div>
            </MainContainer>
            <MenuCom pathname={pathname} show={show} close={()=>setShow(false)}/>
        </div>
    )
}
